const CarChooser = {

    init() {
        this.el = $('[component="CarChooser"]');
        if (!this.el.length) return;

        this.brand = this.el.find('select.brand');
        this.model = this.el.find('select.model');
        this.slider = this.el.find('.slider');
        this.form = this.el.closest('form');
        this.bind();
        this.emptyCars();
    },

    bind() {
        this.brand.change((evt) => {
            const val = $(evt.currentTarget).val();
            this.loadModels(val);
        })

        this.model.change((evt) => {
            const val = $(evt.currentTarget).val();
            this.loadCars(val);
        })
    },

    loadModels(brand_id) {
        $.ajax({
            data: {'action': 'models', 'brand_id': brand_id},
            dataType: 'json',
            url: WEB_ROOT + '/modules/stock_locator/views/CarChooser/CarChooser.async.php',
            type: 'POST',
            success: (response, textStatus, jqXHR) => {
                if (response.success) {
                    this.prepareModels(response.data)
                } else {
                    console.error('something wen wrong in loadModels')
                }
            },
            error: (data, textStatus, jqXHR) => {
                console.error(data, textStatus, jqXHR)
            }
        });
    },

    prepareModels(models) {
        this.emptyCars();
        const first = this.model.find('option:first');
        this.model.empty();
        first.appendTo(this.model);

        models.forEach((el, i) => {
            $('<option/>').attr('value', el.id).text(el.name).appendTo(this.model);
        })

        this.model.trigger('chosen:updated');
    },

    loadCars(model_id) {
        $.ajax({
            data: {'action': 'cars', 'model_id': model_id},
            dataType: 'json',
            url: WEB_ROOT + '/modules/stock_locator/views/CarChooser/CarChooser.async.php',
            type: 'POST',
            success: (response, textStatus, jqXHR) => {
                if (response.success) {
                    this.prepareCars(response.data)
                } else {
                    console.error('something wen wrong in loadCars')
                }
            },
            error: (data, textStatus, jqXHR) => {
                console.error(data, textStatus, jqXHR)
            }
        });
    },

    emptyCars() {
        const empty = $('<div class="empty"><div class="img"><img src="/preview-file/blank.webp"/></div> <h5>' + window.T.STL.empty_car + '</h5></div>')
        this.slider.empty().append(empty);
    },

    prepareCars(cars) {
        this.slider.empty().append(cars);
        this.initSlider(this.slider.find('#cars'));
    },

    initSlider(slider) {
        slider.addClass('owl-carousel');

        slider.on('initialized.owl.carousel', (evt) => {
            this.setCar();
        });

        slider.on('translated.owl.carousel', (evt) => {
            this.setCar();
        })

        slider.owlCarousel({
            "smartSpeed": 750,
            "loop": false,
            "autoWidth": false,
            "nav": true,
            "dots": false,
            "progress": false,
            "counter": false,
            "margin": 8,
            "stagePadding": 0,
            "items": 1,
            "navText": ["", ""],
        });
    },

    setCar() {
        const car = this.slider.find('.owl-item.active .car');
        const data = {
            'id': car.attr('id'),
            'name' : car.find('.info h3').text(),
        }
        this.form.find('.input.car_id input[type="hidden"]').val(data.id);
        this.form.find('[name="car_id"]').val(data.id);
        this.form.find('[name="car_name"]').val(data.name);
        this.form.find('[name="car_image"]').val(WEB_ROOT + '/' + car.find('.image img').attr('src'));
        this.form.find('[name="car_price"]').val(car.find('.price b').text());
        this.form.find('[name="car_url"]').val(WEB_ROOT + '/' + car.attr('href'));

        this.setDataLayer(data);
    },

    setDataLayer(data){
        console.log(window.useDatalayer)
        dataLayer_form.ecommerce.items[0].item_name = data.name

        // dataLayer_form = {
        //     event: 'begin_checkout',
        //     ecommerce: {
        //         items: [{
        //             item_name: '<?= $car["name"] ?>',
        //             item_id: '<?= $car["vin_full"] ?>',
        //             price: '<?= carPrice($car) ?>',
        //             item_brand: '<?= carBrand($car['znacka_id']) ?>',
        //             item_category: '<?= $this->modelID[$car['model_id']] ?>',
        //             item_category2: '<?= $this->palivoID[$car['palivo_id']] ?>',
        //             item_category3: '<?= $this->mileageName($car['mileage_id']) ?>',
        //             item_category4: 'interest',
        //             quantity: '1'
        //         }]
        //     }
        // };
    }

}

export default CarChooser;